import ExamRequires from './ExamRequires.gql';

export default ExamRequires;
